import { axios } from '@/utils/request'

const api = {
    getStartList: '/wyhadminapi/dscore/startList',
    getStartMachineList: '/wyhadminapi/dscore/scoreMachineList',
    getStartMachineRankList: '/wyhadminapi/dscore/scoreMachineRankList',
    getStartMachineDetail: '/wyhadminapi/dscore/scoreMachineDetail',
    startListOptions: '/wyhadminapi/dscore/startListOptions',
    startListSave: '/wyhadminapi/dscore/startListSave',
    startListTimeSave: '/wyhadminapi/dscore/startListTimeSave',
    getScoreUserList: '/wyhadminapi/dscore/scoreUserList',
    addScoreUser: '/wyhadminapi/dscore/addScoreUser',
    deleteScoreUser: '/wyhadminapi/dscore/deleteScoreUser',
    editScoreStartCurrent: '/wyhadminapi/dscore/editScoreStartCurrent',
    setStatus: '/wyhadminapi/dscore/setStatus',
    setShow: '/wyhadminapi/dscore/setShow',
    startListDelete: '/wyhadminapi/dscore/startListDelete',
    getScoreList: '/wyhadminapi/dscore/scoreList',
    getScoreRankList: '/wyhadminapi/dscore/scoreRankList',
    getStartRunList: '/wyhadminapi/dscore/startRunList',
    setScore: '/wyhadminapi/dscore/setScore',
    setCurrent: '/wyhadminapi/dscore/setCurrent',
    getSubjectScoreList: '/wyhadminapi/dscore/subjectScoreList',
    createRankBook: '/wyhadminapi/dscore/createRankBook',
    createPrize: '/wyhadminapi/dscore/createPrize',
    subjectScoreDetail: '/wyhadminapi/dscore/subjectScoreDetail',
    subjectScoreEdit: '/wyhadminapi/dscore/subjectScoreEdit',
    getCreateRankUrls: '/wyhadminapi/dscore/getCreateRankUrls',
    getAllMusicUrls: '/wyhadminapi/dscore/getAllMusicUrls',
    setCaipanStatus: '/api/dscore/caipanStatusChange',
    setSubjectStatus: '/wyhadminapi/dscore/setSubjectStatus',
    setTime: '/wyhadminapi/dscore/setTime',
    getCommentOptions: '/adminapi/dscore/getCommentOptions',
    zhixuceDownload: '/wyhadminapi/dscore/zhixuceDownload',
    startListForMakeOptions: '/wyhadminapi/dscore/startListForMakeOptions',

}

export default api

export function setCaipanStatus(parameter) {
    return axios({
        url: api.setCaipanStatus,
        method: 'post',
        data: parameter
    })
}

export function startListForMakeOptions(parameter) {
    return axios({
        url: api.startListForMakeOptions,
        method: 'get',
        params: parameter
    })
}
export function startListOptions(parameter) {
    return axios({
        url: api.startListOptions,
        method: 'get',
        params: parameter
    })
}
export function getStartList(parameter) {
    return axios({
        url: api.getStartList,
        method: 'get',
        params: parameter
    })
}
export function startListSave(parameter) {
    return axios({
        url: api.startListSave,
        method: 'post',
        data: parameter
    })
}

export function startListTimeSave(parameter) {
    return axios({
        url: api.startListTimeSave,
        method: 'post',
        data: parameter
    })
}

export function deleteScoreUser(parameter) {
    return axios({
        url: api.deleteScoreUser,
        method: 'post',
        data: parameter
    })
}
export function addScoreUser(parameter) {
    return axios({
        url: api.addScoreUser,
        method: 'post',
        data: parameter
    })
}

export function setStatus(parameter) {
    return axios({
        url: api.setStatus,
        method: 'post',
        data: parameter
    })
}

export function setShow(parameter) {
    return axios({
        url: api.setShow,
        method: 'post',
        data: parameter
    })
}


export function getScoreUserList(parameter) {
    return axios({
        url: api.getScoreUserList,
        method: 'get',
        params: parameter
    })
}

export function startListDelete(parameter) {
    return axios({
        url: api.startListDelete,
        method: 'get',
        params: parameter
    })
}
export function getScoreList(parameter) {
    return axios({
        url: api.getScoreList,
        method: 'get',
        params: parameter
    })
}
export function getScoreRankList(parameter) {
    return axios({
        url: api.getScoreRankList,
        method: 'get',
        params: parameter
    })
}
export function getStartRunList(parameter) {
    return axios({
        url: api.getStartRunList,
        method: 'get',
        params: parameter
    })
}
export function getSubjectScoreList(parameter) {
    return axios({
        url: api.getSubjectScoreList,
        method: 'get',
        params: parameter
    })
}
export function setScore(parameter) {
    return axios({
        url: api.setScore,
        method: 'post',
        data: parameter
    })
}
export function setCurrent(parameter) {
    return axios({
        url: api.setCurrent,
        method: 'post',
        data: parameter
    })
}
export function createRankBook(parameter) {
    return axios({
        url: api.createRankBook,
        method: 'post',
        data: parameter
    })
}
export function createPrize(parameter) {
    return axios({
        url: api.createPrize,
        method: 'post',
        data: parameter
    })
}
export function subjectScoreDetail(parameter) {
    return axios({
        url: api.subjectScoreDetail,
        method: 'get',
        params: parameter
    })
}
export function subjectScoreEdit(parameter) {
    return axios({
        url: api.subjectScoreEdit,
        method: 'post',
        data: parameter
    })
}
export function getCreateRankUrls(parameter) {
    return axios({
        url: api.getCreateRankUrls,
        method: 'post',
        data: parameter
    })
}

export function getAllMusicUrls(parameter) {
    return axios({
        url: api.getAllMusicUrls,
        method: 'post',
        data: parameter
    })
}

export function scoreCommentOptions(parameter) {
    return axios({
        url: api.getCommentOptions,
        method: 'get',
        params: parameter
    })
}

export function setSubjectStatus(parameter) {
    return axios({
        url: api.setSubjectStatus,
        method: 'post',
        data: parameter
    })
}


export function getStartMachineList(parameter) {
    return axios({
        url: api.getStartMachineList,
        method: 'get',
        params: parameter
    })
}

export function getStartMachineRankList(parameter) {
    return axios({
        url: api.getStartMachineRankList,
        method: 'get',
        params: parameter
    })
}

export function getStartMachineDetail(parameter) {
    return axios({
        url: api.getStartMachineDetail,
        method: 'get',
        params: parameter
    })
}


export function editScoreStartCurrent(parameter) {
    return axios({
        url: api.editScoreStartCurrent,
        method: 'post',
        data: parameter
    })
}

export function zhixuceDownload(parameter) {
    return axios({
        url: api.zhixuceDownload,
        method: 'post',
        data: parameter
    })
}